export default function () {
  // https://github.com/scdoshi/jquery-ajaxchimp
  'use strict';

  $.ajaxChimp = {
    responses: {
      'We have sent you a confirmation email'                                             : 0,
      'Please enter a value'                                                              : 1,
      'An email address must contain a single @'                                          : 2,
      'The domain portion of the email address is invalid (the portion after the @: )'    : 3,
      'The username portion of the email address is invalid (the portion before the @: )' : 4,
      'This email address looks fake or invalid. Please enter a real email address'       : 5
    },
    translations: {
      'en': null,
      'de': {
        'submit': 'Übertrage...',
        0: 'Wir haben Ihnen eine Bestätigungs-E-Mail gesendet',
        1: 'Bitte geben Sie einen Wert ein',
        2: 'Eine E-Mail-Adresse muss ein einzelnes @ enthalten',
        3: 'Der Domänenteil der E-Mail-Adresse ist ungültig (der Teil nach dem @: )',
        4: 'Der Teil des Benutzernamens der E-Mail-Adresse ist ungültig (der Teil vor dem @: )',
        5: 'Diese E-Mail-Adresse sieht gefälscht oder ungültig aus. Bitte geben Sie eine echte E-Mail-Adresse ein'
      },
      'fr': {
        'submit': 'Soumission...',
        0: 'Nous vous avons envoyé un e-mail de confirmation',
        1: 'Veuillez entrer une valeur',
        2: 'Une adresse e-mail doit contenir un seul @',
        3: 'La partie domaine de l\'adresse e-mail est invalide (la partie après le @: )',
        4: 'La partie nom d\'utilisateur de l\'adresse e-mail est invalide (la partie avant le @: )',
        5: 'Cette adresse e-mail semble fausse ou invalide. S\'il vous plaît entrer une adresse email réelle'
      }
    },
    init: function (selector, options) {
      $(selector).ajaxChimp(options);
    }
  };

  $.fn.ajaxChimp = function (options) {
    $(this).each(function(i, elem) {
      var form = $(elem);
      var email = form.find('input[type=email]');
      var message = form.find('.newsletter-box-response');
      var button = form.find('button');

      var settings = $.extend({
        'url': form.attr('action'),
        'language': 'de'
      }, options);

      var url = settings.url.replace('/post?', '/post-json?').concat('&c=?');

      form.attr('novalidate', 'true');
      email.attr('name', 'EMAIL');

      form.submit(function () {
        var msg;
        function successCallback(resp) {
          if (resp.result === 'success') {
            msg = message.data('success-message');
            message.removeClass('error').addClass('valid');
            email.removeClass('error').addClass('valid');
          } else {
            email.removeClass('valid').addClass('error');
            message.removeClass('valid').addClass('error');
            var index = -1;
            try {
              var parts = resp.msg.split(' - ', 2);
              if (parts[1] === undefined) {
                msg = resp.msg;
              } else {
                var i = parseInt(parts[0], 10);
                if (i.toString() === parts[0]) {
                  index = parts[0];
                  msg = parts[1];
                } else {
                  index = -1;
                  msg = resp.msg;
                }
              }
            }
            catch (e) {
              index = -1;
              msg = resp.msg;
            }
          }

          // Translate and display message
          if (
            settings.language !== 'en'
            && $.ajaxChimp.responses[msg] !== undefined
            && $.ajaxChimp.translations
            && $.ajaxChimp.translations[settings.language]
            && $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]
          ) {
            msg = $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]];
          }
          message.html(msg);

          message.removeClass('hidden');
          button.addClass('hidden');
          if (settings.callback) {
            settings.callback(resp);
          }
        }

        var data = {};
        var dataArray = form.serializeArray();
        $.each(dataArray, function (index, item) {
          data[item.name] = item.value;
        });

        $.ajax({
          url: url,
          data: data,
          success: successCallback,
          dataType: 'jsonp',
          error: function (resp, text) {
            console.log('mailchimp ajax submit error: ' + text);
          }
        });

        // Translate and display submit message
        var submitMsg = 'Submitting...';
        if(
          settings.language !== 'en'
          && $.ajaxChimp.translations
          && $.ajaxChimp.translations[settings.language]
          && $.ajaxChimp.translations[settings.language]['submit']
        ) {
          submitMsg = $.ajaxChimp.translations[settings.language]['submit'];
        }
        message.html(submitMsg).removeClass('hidden');

        return false;
      });
    });
    return this;
  };

  if ($('.ajaxchimp').length) {
    $('.ajaxchimp').ajaxChimp({
      language: document.querySelector('html').getAttribute('lang') || 'de'
    });
  }
}
